import Vue from 'vue'

const AnimateCSS = require('vue2-animate/dist/vue2-animate.min.css')
Vue.use(AnimateCSS);
